import { render, staticRenderFns } from "./MarketAreaTab.vue?vue&type=template&id=2e3cc62b"
import script from "./MarketAreaTab.vue?vue&type=script&lang=js"
export * from "./MarketAreaTab.vue?vue&type=script&lang=js"
import style0 from "./MarketAreaTab.vue?vue&type=style&index=0&id=2e3cc62b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports